import { useState, useRef } from 'react'
import { useRequests } from '../requests/useRequests'

export const useImageUpload = (onImageUploaded: (imageUrl: string) => void, onError: (message: string) => void, onSuccess: (message: string) => void) => {
  const [imageUploading, setImageUploading] = useState<boolean>(false)
  const [imagePreview, setImagePreview] = useState<string | null>(null)
  const fileInputRef = useRef<HTMLInputElement>(null)

  const requests = useRequests()

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file == null) return

    try {
      setImageUploading(true)

      const reader = new FileReader()
      reader.onloadend = () => {
        setImagePreview(reader.result as string)
      }
      reader.readAsDataURL(file)

      const response = await requests.uploadFile(file, 'blog')

      setImagePreview(response.data.presignedUrl)
      onImageUploaded(response.data.fileKey)
      onSuccess('Obraz został pomyślnie przesłany')
    } catch (err: any) {
      onError(err.data?.message || 'Nie udało się przesłać obrazu. Spróbuj ponownie.')
      console.error('Błąd podczas przesyłania obrazu:', err)
      setImagePreview(null)
    } finally {
      setImageUploading(false)
    }
  }

  const triggerFileInput = () => {
    fileInputRef.current?.click()
  }

  const setInitialPreview = (imageUrl: string) => {
    if (imageUrl && !imagePreview) {
      setImagePreview(imageUrl)
    }
  }

  return {
    imageUploading,
    imagePreview,
    fileInputRef,
    handleFileUpload,
    triggerFileInput,
    setInitialPreview
  }
}
